// extracted by mini-css-extract-plugin
export default {"magnifier":"TabFiltrText_magnifier__jq0EP","optionsList":"TabFiltrText_optionsList__Dz1E2","cell":"TabFiltrText_cell__nPPAv"};